module.exports = __webpack_public_path__ + "assets/img/7.ca3df909.jpg";